<div class="card" [formGroup]="fg">
  <div class="card-header">Request Reimbursement</div>
  <div class="card-body" mat-dialog-content>
    <div class="grid grid-cols-12 gap-x-4">
      <div class="col-span-12">
        <div class="mb-4">
          <label class="form-label">Purpose <span class="text-red-400">*</span> </label>
          <input [formControl]="fg.controls.Purpose" type="text" class="form-control">
          <small *ngIf="fg.controls.Purpose.touched && fg.controls.Purpose.invalid" class="text-red-400">* Purpose is
            required.</small>
        </div>
      </div>
    </div>
    <div formArrayName="Items">
      <div class="font-bold text-lg mb-4">
        Reimbursement Items
      </div>
      <div *ngIf="!fg.controls.Items.controls.length" class="alert alert-warning">
        Please add at least 1 Item to continue.
      </div>
      <div *ngFor="let fgItem of fg.controls.Items.controls; let fgi = index" class="bg-white shadow border mb-4 p-4">
        <div [formGroup]="fgItem" class="grid grid-cols-12 gap-x-4">
          <div class="col-span-12">
            <div class="mb-4">
              <div class="flex justify-between">
                <span class="font-bold text-lg">Item #{{fgi + 1}}</span>
                <button [disabled]="waitHandler.processing" (click)="removeItemAt(fgi, fgItem.controls.Id.value)"
                  type="button" class="custom-button-sm custom-button-primary">
                  <i class="fal fa-trash"></i> Remove Item
                </button>
              </div>
            </div>
          </div>
          <div class="col-span-12">
            <div class="mb-4">
              <label class="form-label">Description <span class="text-red-400">*</span> </label>
              <input [formControl]="fgItem.controls.Description" type="text" class="form-control">
              <small *ngIf="fgItem.controls.Description.touched && fgItem.controls.Description.invalid"
                class="text-red-400">*
                Description is required.
              </small>
            </div>
          </div>
          <div class="col-span-12 md:col-span-4">
            <div class="mb-4">
              <label class="form-label">Vatable Sales <span class="text-red-400">*</span> </label>
              <div class="form-group">
                <div class="form-group-label">₱</div>
                <input [formControl]="fgItem.controls.VatableSales" (keypress)="Helper.input.positiveNumeric($event)"
                  type="number" class="form-group-input">
              </div>
              <small *ngIf="fgItem.controls.VatableSales.touched && fgItem.controls.VatableSales.invalid"
                class="text-red-400">*
                Vatable Sales is required.</small>
            </div>
          </div>
          <div class="col-span-12 md:col-span-4">
            <div class="mb-4">
              <label class="form-label">VAT</label>
              <div class="form-group">
                <div class="form-group-label">₱</div>
                <input [formControl]="fgItem.controls.VAT" (keypress)="Helper.input.positiveNumeric($event)"
                  type="number" class="form-group-input">
              </div>
            </div>
          </div>
          <div class="col-span-12 md:col-span-4">
            <div class="mb-4">
              <label class="form-label">Proof <span class="text-red-400">*</span> </label>
              <div class="form-group">
                <div class="form-group-label">
                  <i class="fa-light fa-receipt"></i>
                </div>
                <label class="form-group-input cursor-pointer" for="{{fgi}}-tab-tr-updload-proof">
                  {{fgItem.controls.Proof.value?.name ||'Upload Proof'}}
                </label>
                <input (input)="onUploadProof($event, fgi)" type="file" class="hidden" placeholder="Upload Proof"
                  accept=".pdf, .png, .jpg, .jpeg" id="{{fgi}}-tab-tr-updload-proof">
              </div>
              <small *ngIf="fgItem.controls.Proof.touched && fgItem.controls.Proof.invalid" class="text-red-400">* Proof
                is required.</small>
            </div>
          </div>
          <div class="col-span-12">
            <div class="mb-4">
              <label class="form-label">Remarks</label>
              <input [formControl]="fgItem.controls.Remarks" type="text" class="form-control">
            </div>
          </div>
        </div>
      </div>
      <div class="font-bold mb-4">
        <div class="form-submit">
          <button [disabled]="waitHandler.processing" (click)="addItem()" type="button"
            class="custom-button-sm custom-button-primary">
            <i class="fal fa-plus-circle"></i> Add Item
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="card-footer">
    <div *ngIf="prompt.message" class="alert alert-{{prompt.type}} mb-4">{{prompt.message}}</div>
    <div class="text-end font-bold text-lg mb-4 border bg-zinc-50 p-4">
      <span class="text-red-400">Total: {{totalComputedAmount$|async|currency:'₱ '}}</span>
    </div>
    <div class="form-submit">
      <button [disabled]="waitHandler.processing" class="custom-button custom-button-primary" type="submit"
        (click)="onSubmit()">Save</button>
      <button [disabled]="waitHandler.processing" class="custom-button" type="button" mat-dialog-close>Cancel</button>
    </div>
  </div>
</div>